  import { gtmEventType, phoneType } from '@Components/Utilities/SandhillsConstants';
import { getDistinct, gtmPushEvent, sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import TextMessage from '@Components/Contact/TextMessage';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import Icon from '@mui/material/Icon';
import { ThemedLinkButton } from '@Components/MuiWrappers/Button';
import Typography from '@mui/material/Typography';
import translator from '@Components/Utilities/Translator';

const PhoneLink = (props) => {

    const currentUser = useRecoilValue(atoms.currentUser);
    const routes = useRecoilValue(atoms.routes);

    const phoneClickToTrack = (e, phoneNumber, phoneType) => {
        if (!currentUser.IsSearchEngine && props.PhoneClickToTrackURL) {
            let element = e.target;
            sandhillsRequest({
                url: props.PhoneClickToTrackURL,
                method: 'post',
                data: {
                    PhoneNumber: phoneNumber,
                    PhoneType: phoneType
                },
                errorHandling: {
                    useConsole: false,
                    useAlert: false
                }
            }).then(() => {
                element.setAttribute('data-impression-logged', 'true');
            }).catch(() => {
                element.setAttribute('data-impression-logged', 'false');
            });
        }
    };

    const saveIterableAction = (actionName) => {
        sandhillsRequest({
            url: routes.SaveAction,
            method: 'post',
            data: {
                'email': '',
                'actionName': actionName,
                'manufacturers': [props.Manufacturer],
                'models': [props.Model],
                'listingTypes': [props.ListingType],
                'categoryIDs': getDistinct([props.CategoryID, props.AltCategoryID]),
                'listingIDs': [props.ListingID],
                'partIDs': [props.PartID],
                'conditions': [props.Condition]
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        });
    };

    const handleTelClick = (e) => {
        if (e == phoneType.Rental) gtmPushEvent(gtmEventType.callRental);
        else if (e == phoneType.Wholesale) gtmPushEvent(gtmEventType.callWholesale);
        else gtmPushEvent(gtmEventType.call);
        saveIterableAction('telClick');
    }

    if (props.IsFBMessenger) {
        return (
            <ThemedLinkButton variant='text' size='small' href={props.FBMessengerLink} data-phonetype='FB' className={'dealer-contact__link'} target='_blank' onClick={(e) => { phoneClickToTrack(e, props.FBMessengerID, 'Facebook Messaging'); gtmPushEvent(gtmEventType.messenger); }}>
                {props.ShowIcon &&
                    <Icon baseClassName='fab' className='fa-facebook-messenger dealer-contact__icon' sx={{ color: 'contrastDefault.main' }} />}
                <TranslationText tKey='sandhills.fbmessenger' />
                <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
                <Icon baseClassName='fas' className='fa-external-link-alt' />
            </ThemedLinkButton>
        );
    } else if (props.IsWhatsApp) {
        return (
            <ThemedLinkButton variant='text' size='small' href={props.WhatsAppLink} data-phonetype='WhatsApp Text Phone' className={'dealer-contact__link'} target='_blank' onClick={(e) => { phoneClickToTrack(e, props.WhatsAppUnformattedPhoneNumber, 'WhatsApp Text Phone'); gtmPushEvent(gtmEventType.whatsApp); }}>
                {props.ShowIcon &&
                    <Icon baseClassName='fab' className='fa-whatsapp dealer-contact__icon' sx={{ color: 'contrastDefault.main' }} />}
                <TranslationText tKey='sandhills.whatsapp' />
                <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
                <Icon baseClassName='fas' className='fa-external-link-alt' />
            </ThemedLinkButton>
        );
    } else {
        return (
            <>
                <Typography variant='body2' className='dealer-contact__phone-number'>
                    {props.showPhoneLabel &&
                        <span className='dealer-contact__label'><TranslationText tKey='sandhills.phone' />:</span>
                    }
                    <ThemedLinkButton variant='text' size='small' href={'tel:' + props.UnformattedPhone} data-phonetype={props.PhoneType} className='dealer-contact__link' onClick={(e) => { phoneClickToTrack(e, props.UnformattedPhone, props.PhoneType); handleTelClick(props.PhoneType); }}>
                        {props.ShowIcon &&
                            <Icon baseClassName='fas' className='fa-phone-alt fa-flip-horizontal gtm-noclick dealer-contact__icon' sx={{ color: 'contrastDefault.main' }} />}
                        <span className='gtm-noclick dealer-contact__link-text'>{props.Phone}</span>
                        {props.ShowIcon && <Icon baseClassName='fas' className='fa-external-link-alt' />}
                    </ThemedLinkButton>
                </Typography>
                <div className='dealer-contact__phone-number'>
                    {props.isMobile && props.PhoneType == phoneType.Retail && props.IsRetailPhoneNumberTextEnabled &&
                        <>
                            {props.showTextLabel &&
                                <span className='dealer-contact__label'><TranslationText tKey='sandhills.crm.dscrm.text' />:</span>
                            }
                            <TextMessage messagePhone={props.UnformattedPhone} messageBody={props.TextMessageBody} buttonText={props.Phone} onPhoneClickToTrack={phoneClickToTrack} isDetailPage />
                        </>
                    }
                </div>
            </>
        );
    }
};

export default PhoneLink;